import store from '@/store'

export default async (_, _1, next) => {
  await store.dispatch('getPoiCheckUrl')
  next()
}
